/**
 * @file The Component contains the whole Configuration information for user to review their choices
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import React from 'react';
import { Button, Row, Icon } from 'antd';

//funcs & data
import { generateWinResponseFile } from '../../../../FileGenerator/FileGenerator';
import {
    state2PrefixMap,
    state2CommentMap,
} from '../../../../Utils/WindowsDataLoader';
import { triggerLambda } from '../../../../Utils/utils';
import * as DEFINITIONS from '../../../../Utils/Constants';

//css
import 'antd/dist/antd.css';
import '../../../../Utils/CommonCss.css';

class WinFinalPage extends React.Component {
    /**
     * Change the state of initialPage to go back to License Agreement page
     */
    backToLicensePage = () => {
        this.props.setBasicState('initialPage', true);
    };

    backStep = () => {
        this.backToLicensePage();
    };

    /**
     * To generate the Response_Update1.ini and download it locally
     */
    downloadTxtFile = () => {
        const element = document.createElement('a');
        let res = generateWinResponseFile(
            this.props,
            state2PrefixMap,
            state2CommentMap
        );
        let fileName;
        switch (this.props.useVersion) {
            case DEFINITIONS.M2021_UPDATE1:
                fileName = 'response_m2021_u1.ini';
                break;
            case DEFINITIONS.M2021_UPDATE2:
                fileName = 'response_m2021_u2.ini';
                break;
            case DEFINITIONS.M2021_UPDATE3:
                fileName = 'response_m2021_u3.ini';
                break;
            default:
        }
        let file = new File([res], fileName, {
            type: 'text/plain',
        });

        element.href = URL.createObjectURL(file);
        element.download = file.name;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();

        let info = {
            fileName: file.name,
            companyName: null, // no company name
            os: this.props.useOs,
            mode: this.props.useMode,
            version: this.props.useVersion,
        };

        //upload to s3
        triggerLambda(
            info,
            function (response) {
                console.log('Success!');
            },
            function (error) {
                console.error(error);
            }
        );
    };

    render() {
        let updateVersion = 1;
        let majorVersion = 2020;

        switch (this.props.useVersion) {
            case DEFINITIONS.M2021_UPDATE1:
                updateVersion = 1;
                majorVersion = 2021;
            case DEFINITIONS.M2021_UPDATE2:
                updateVersion = 2;
                majorVersion = 2021;
            case DEFINITIONS.M2021_UPDATE3:
                updateVersion = 3;
                majorVersion = 2021;
            default:
        }

        return (
            <Row type="flex" align="top">
                <div className="win-update-content">
                    <div className="win-update-img-content">
                        <img
                            className="all-set-img"
                            src={require('../../../../assets/Icons/Defualt Image.svg')}
                            alt="Success Img"
                        />
                    </div>
                    <b>You are all set to go!</b>
                    <br />
                    Please proceed to generate the file for MicroStrategy{' '}
                    {majorVersion} Update {updateVersion}
                </div>
                <div className="buttonBar">
                    <div className="description">
                        You are creating a configuration file for
                        <img
                            src={require('../../../../assets/Icons/Windows.png')}
                            alt="Operating System"
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            className="buttonBack"
                            type="default"
                            onClick={this.backStep}
                        >
                            Back
                        </Button>
                        <Button
                            className="buttonNext"
                            type="primary"
                            onClick={this.downloadTxtFile}
                        >
                            <Icon type="vertical-align-bottom" />
                            Download File
                        </Button>
                    </div>
                </div>
            </Row>
        );
    }
}

export default WinFinalPage;
